(function profileDetailControllerDefinition() {
    'use strict';
    angular.module('Profile')
        .controller('ProfileDetailController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'userService', '$stateParams', 'authExtend', 'loginService',
            function profileDetailController($scope, config, $state, $translate, errors, userService, $stateParams, authExtend, loginService) {

                $scope.user = {
                    organizationalUnitName: ''
                };
                $scope.canEdit = authExtend.isInRole('PROFILE MODIFY');
                loginService.getLogged()
                    .then(function (result) {
                        $scope.user = result;
                        $scope.user.organizationalUnitName = authExtend.getOrganizationName()
                    }, function (error) {
                        errors.showError(error);
                        $state.go('inicio');
                    });

                $scope.edit = function () {
                    $state.go("edit-profile");
                };
            }
        ]);
})();